import React from "react";

export default function LandingPage() {
  const onJoin = () => alert("Onboarding restauracji już wkrótce");

  return (
    <div style={styles.page}>
      <style>{css}</style>
     <header style={styles.nav}>
          <div style={styles.brand}>
            <span style={styles.logoDot} />
            <span style={styles.brandText}>LunGO</span>
          </div>
          <nav style={styles.navLinks}>
            <a href="#what" className="link">
              Czym jest LunGO?
            </a>
            <a href="#compare" className="link">
              LunGO vs Inni
            </a>
            <a href="#join" className="link">
              Dołącz
            </a>
          </nav>
        </header>
      {/* HERO */}
      <section style={styles.hero}>
        {/* NAV */}
   
        <div style={styles.heroInner}>
          <h1 style={styles.h1}>Zamawiaj mądrzej. Płać mniej. Zawsze.</h1>
          <p style={styles.lead}>
            LunGO łączy Cię bezpośrednio z lokalnymi restauracjami — bez
            ukrytych opłat, uczciwe ceny, szybka dostawa.
          </p>
          <div style={styles.ctaRow}>
            <button className="btn primary" onClick={onJoin}>
              Dołącz jako restauracja
            </button>
          </div>
          <ul style={styles.badges}>
            <li>🍕 Niższe ceny</li>
            <li>⚡ Szybkie zamówienia</li>
            <li>💚 Wspieraj lokalnych</li>
          </ul>
        </div>
      </section>

      {/* WHAT IS LUNGO */}
      <section id="what" style={styles.section}>
        <h2 style={styles.h2}>Czym jest LunGO?</h2>
        <p style={styles.p}>
          <strong>LunGO</strong> to nowoczesna polska platforma, która pozwala
          klientom zamawiać bezpośrednio z restauracji. Restauracje zachowują
          większy zysk, a klienci płacą mniej — wszyscy wygrywają.
        </p>
        <div style={styles.cards}>
          {[
            ["Brak ukrytych opłat", "Transparentne ceny dla wszystkich."],
            ["Bezpośrednie zamówienia", "Bez pośredników i prowizji."],
            ["Program lojalnościowy", "Zbieraj punkty i odbieraj nagrody."],
            ["Bezpieczne płatności", "PayU i Stripe w jednym kliknięciu."],
          ].map(([title, desc]) => (
            <div key={title} className="card">
              <h3>{title}</h3>
              <p>{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* COMPARISON */}
      <section id="compare" style={styles.section}>
        <h2 style={styles.h2}>LunGO vs Inni</h2>
        <div className="tableWrap">
          <table className="table">
            <thead>
              <tr>
                <th>Funkcja</th>
                <th>LunGO</th>
                <th>Inni</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Prowizja od zamówienia</td>
                <td>
                  <strong>Pay-as-you-grow</strong>
                </td>
                <td>15–18%</td>
              </tr>
              <tr>
                <td>Wynajem tabletu</td>
                <td>Nie</td>
                <td>Tak (~1000 PLN jednorazowo)</td>
              </tr>
              <tr>
                <td>Opłaty marketingowe</td>
                <td>Nie</td>
                <td>Tak </td>
              </tr>
              <tr>
                <td>Opłaty doliczane klientom</td>
                <td>Nie</td>
                <td>Tak, do 2%</td>
              </tr>
              <tr>
                <td>Panel restauracji</td>
                <td>Pełna kontrola</td>
                <td>Ograniczona</td>
              </tr>
              <tr>
                <td>Własne strony lokali</td>
                <td>W cenie</td>
                <td>Brak możliwości</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* HOW TO JOIN */}
      <section id="join" style={styles.section}>
        <h2 style={styles.h2}>Jak dołączyć</h2>
        <div className="joinCol">
          <h3>Dla restauracji</h3>
          <div className="steps">
            {[
              ["1", "Wypełnij formularz Early Access", "Zajmie to 2 minuty."],
              [
                "2",
                "Weryfikacja i akceptacja",
                "Zespół LunGO aktywuje Twoje konto.",
              ],
              ["3", "Start z LunGO", "Dodaj menu i przyjmuj zamówienia!"],
            ].map(([n, title, text]) => (
              <div key={n} className="step">
                <div className="stepNum">{n}</div>
                <div>
                  <h4 className="stepTitle">{title}</h4>
                  <p className="stepText">{text}</p>
                </div>
              </div>
            ))}
          </div>
          <button className="btn primary" style={{ marginTop: 20 }}>
            Aplikuj teraz
          </button>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={styles.footer}>
        <span className="muted">Made with ❤️ in Poland</span>
      </footer>
    </div>
  );
}

const styles = {
  page: {
    background: "var(--color-bg)",
    color: "var(--color-text)",
    fontFamily: "Poppins, sans-serif",
  },
  nav: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: 64,
    padding: "0 20px",
    borderBottom: "1px solid var(--color-light)",
    background: "rgba(255,255,255,0.9)",
    backdropFilter: "blur(8px)",
    position: "sticky",
    top: 0,
    zIndex: 50,
  },
  brand: { display: "flex", alignItems: "center", gap: 10, fontWeight: 700 },
  brandText: { fontSize: 22, color: "var(--color-heading)" },
  logoDot: {
    width: 16,
    height: 16,
    background: "var(--color-primary)",
    borderRadius: "50%",
  },
  navLinks: { display: "flex", gap: 14 },
  hero: {
    textAlign: "center",
    padding: "100px 20px 60px",
    position: "relative",
  },
  heroInner: { maxWidth: 960, margin: "0 auto" },
  h1: { fontSize: 48, fontWeight: 800, color: "var(--color-heading)" },
  lead: {
    color: "var(--color-muted)",
    maxWidth: 700,
    margin: "10px auto 20px",
  },
  ctaRow: { marginTop: 20 },
  badges: {
    display: "flex",
    justifyContent: "center",
    gap: 20,
    color: "var(--color-primary)",
  },
  heroArt: { position: "absolute", inset: 0, zIndex: -1 },
  section: { maxWidth: 1080, margin: "0 auto", padding: "60px 20px" },
  h2: {
    fontSize: 32,
    fontWeight: 800,
    color: "var(--color-heading)",
    textAlign: "center",
    marginBottom: 24,
  },
  p: { textAlign: "center", color: "var(--color-muted)", fontSize: 16 },
  cards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))",
    gap: 16,
    marginTop: 24,
  },
  footer: {
    borderTop: "1px solid var(--color-light)",
    padding: "40px 20px",
    textAlign: "center",
    color: "var(--color-muted)",
    fontSize: 14,
  },
};

const css = `
html { scroll-behavior: smooth; }

.link {
  color: var(--color-text);
  text-decoration: none;
  font-weight: 600;
  transition: color .2s;
}
.link:hover { color: var(--color-primary-hover); }

.btn {
  padding: 12px 22px;
  border-radius: var(--radius);
  border: none;
  font-weight: 600;
  cursor: pointer;
  transition: all .2s;
}
.btn.primary {
  background: var(--color-primary);
  color: #fff;
  box-shadow: var(--shadow);
}
.btn.primary:hover {
  background: var(--color-primary-hover);
  transform: translateY(-2px);
}

.card {
  background: #fff;
  border-radius: var(--radius);
  border: 1px solid var(--color-light);
  padding: 20px;
  box-shadow: var(--shadow);
  transition: transform .2s ease;
}
.card:hover { transform: translateY(-3px); }

.tableWrap { overflow-x: auto; margin-top: 20px; }
.table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}
.table th, .table td {
  padding: 12px 16px;
  text-align: left;
  border-top: 1px solid var(--color-light);
}
.table th { background: var(--color-light); font-weight: 700; }

.steps {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 20px;
}
.step {
  flex: 1 1 260px;
  background: #fff;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 18px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.stepNum {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--color-primary);
  color: #fff;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stepTitle { font-size: 16px; font-weight: 600; margin: 2px 0; color: var(--color-heading); }
.stepText { font-size: 14px; color: var(--color-muted); }

.blob {
  position:absolute;
  border-radius:50%;
  filter: blur(80px);
  opacity: .25;
}
.b1 { width: 400px; height: 400px; left:-100px; top:-80px; background: var(--color-primary); }
.b2 { width: 300px; height: 300px; right:-120px; bottom:-80px; background: var(--color-promo-bg); }
`;
